import { useMemo } from 'react'
import { useForm, Controller } from 'react-hook-form'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup'

export const initialValues = {
  name: '',
  newemail: '',
  newpassword: '',
}

const useFormCreate = () => {
  const { t } = useTranslation()
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .max(
            50,
            t('ERROR.E000002', {
              field: t('admins.name'),
              character: 50,
            })
          )
          .required(
            t('ERROR.E000001', {
              field: t('admins.name'),
            })
          ),
        newemail: Yup.string()
          .email(t('ERROR.E000004'))
          .max(
            100,
            t('ERROR.E000002', {
              field: t('admins.email'),
              character: 100,
            })
          )
          .required(
            t('ERROR.E000001', {
              field: t('admins.email'),
            })
          ),
        newpassword: Yup.string()
          .max(
            50,
            t('ERROR.E000002', {
              field: t('admins.password'),
              character: 50,
            })
          )
          .min(
            5,
            t('ERROR.E000002', {
              field: t('admins.password'),
              character: 5,
            })
          )
          .required(
            t('ERROR.E000001', {
              field: t('admins.password'),
            })
          ),
      }),
    []
  )

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
    mode: 'onChange',
  })

  return { Controller, methods, initialValues }
}

export default useFormCreate
